<script lang="ts">
  import Spinner from "./Spinner.svelte";
</script>

<div
  class="absolute inset-0 z-10 flex items-center justify-center text-xl bg-olli-500"
>
  <Spinner />
</div>
